"use strict";
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HostController = void 0;
const api_1 = require("@streem/api");
const toolbox_1 = require("@streem/toolbox");
const logger_1 = require("../../util/logger");
class HostController {
    constructor(config) {
        this.config = config;
    }
    getHostUserCallLog() {
        return __awaiter(this, void 0, void 0, function* () {
            (0, toolbox_1.invariant)(this.config.context.remoteUserId, 'Expected remoteUserId to be defined when retrieving call details');
            // We constrain the call log to the last 10 calls but this can be changed if needed
            try {
                const PAGE_SIZE = 10;
                const callEntryDetails = yield api_1.StreemAPI.users.getUserCallLog(this.config.context.remoteUserId.toString(), PAGE_SIZE);
                return callEntryDetails.callLogEntries;
            }
            catch (error) {
                logger_1.logger.error('Error retrieving call log details', error);
            }
        });
    }
}
exports.HostController = HostController;
//# sourceMappingURL=host_controller.js.map